(() => {
  const roots = document.querySelectorAll('[data-hiw-root]');

  roots.forEach((root) => {
    const filterGroup = root.querySelector('[data-hiw-filters]');
    const items = Array.from(root.querySelectorAll('[data-hiw-filter-values]'));
    const resultCount = root.querySelector('[data-hiw-result-count]');

    if (filterGroup && items.length) {
      const buttons = Array.from(filterGroup.querySelectorAll('[data-hiw-filter]'));
      const label = filterGroup.dataset.hiwResultLabel || 'options';

      const applyFilter = (value, updateUrl = true) => {
        let visibleCount = 0;

        items.forEach((item) => {
          const values = (item.dataset.hiwFilterValues || '').split(/\s+/).filter(Boolean);
          const visible = value === 'all' || values.includes(value);
          item.hidden = !visible;
          if (visible) visibleCount += 1;
        });

        buttons.forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.hiwFilter === value));
        });

        if (resultCount) {
          resultCount.textContent = `${visibleCount} ${label}`;
        }

        if (updateUrl && window.history?.replaceState) {
          const url = new URL(window.location.href);
          if (value === 'all') url.searchParams.delete('filter');
          else url.searchParams.set('filter', value);
          window.history.replaceState({}, '', url);
        }
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => applyFilter(button.dataset.hiwFilter));
      });

      const requested = new URL(window.location.href).searchParams.get('filter');
      const initial = buttons.some((button) => button.dataset.hiwFilter === requested) ? requested : 'all';
      applyFilter(initial, false);
    }

    const shapeGroups = Array.from(root.querySelectorAll('[data-hiw-shape-group]'));
    if (shapeGroups.length) {
      const mobile = window.matchMedia('(max-width: 767px)');

      const setShapeGroupState = () => {
        const mode = mobile.matches ? 'mobile' : 'desktop';
        if (root.dataset.hiwShapeMode === mode) return;

        if (mode === 'mobile') {
          shapeGroups.forEach((group, index) => {
            group.open = index === 0;
          });
        } else {
          shapeGroups.forEach((group) => {
            group.open = true;
          });
        }

        root.dataset.hiwShapeMode = mode;
      };

      setShapeGroupState();
      mobile.addEventListener?.('change', setShapeGroupState);
    }
  });
})();
